angular.module('main').directive('isLeadJob', () => ({
	restrict: 'EA',
	scope: {
		job: '=snJob'
	},
	template: ' <span ng-show="isLeadJob">(lead)</span>',
	replace: true,
	transclude: true,
	link(scope) {
		scope.isLeadJob = scope.job.jobWorkflow.progressBarType == 'LEAD';
	}
}));



// WEBPACK FOOTER //
// ./web/js/components/PageJobsOverview/isLeadJob.js